import MoreFeatures from './MoreFeatures'

export default class FreePlan extends React.PureComponent
  render: ->
    <div className="card plan-card free-plan outline-on-hover">
      <div className="card-body gradient-background">
        { @renderTitle()     }
        { @renderPrice()     }
        { @renderCtaButton() }

        <hr/>

        <h4>
          {@props.i18n.dataPrivacy}
        </h4>
        <ul>
          <li>
            <i className="far fa-circle" />
            <span dangerouslySetInnerHTML={{ __html: @props.i18n.partialPrivacy }} />
          </li>
        </ul>

        <hr/>

        <h4>
          {@props.i18n.models}
        </h4>
        <ul>
          <li>
            <i className="far fa-circle-xmark" />
            <span className="disabled">
              {@props.i18n.premiumModels}
            </span>
          </li>
          <li>
            <i className="far fa-circle-check" />
            {@props.i18n.basicModels}
          </li>
        </ul>

        <hr/>

        <h4>
          {@props.i18n.translationLimits}
        </h4>
        <ul>
          <li>
            <i className="far fa-circle" />
            {@props.i18n.limitedUsage}
          </li>
          <li>
            <i className="far fa-circle" />
            {@props.i18n.interfaceChars}
          </li>
          <li>
            <i className="far fa-circle" />
            {@props.i18n.clipboardWatermark}
          </li>
        </ul>

        <div className="flex-grow-1" />

        <MoreFeatures visible={@props.moreFeaturesVisible}
                      toggle={@props.toggleMoreFeatures}
                      i18n={@props.i18n.moreFeatures} />
      </div>
    </div>

  renderTitle: ->
    <h3>
      {@props.i18n.title}
    </h3>

  renderPrice: ->
    <div className="price big">
      <span className="amount">
        0
      </span>
      <span className="currency">
        &euro;
      </span>
      <span className="period">
        {@props.i18n.price.period}
      </span>
    </div>

  renderCtaButton: ->
    if @props.currentUser
      <button className="btn btn-outline-primary" disabled>
        {@props.i18n.ctaButton.currentPlan}
      </button>
    else
      <a className="btn btn-outline-primary"
         href={@props.paths.signUpPath}>
        {@props.i18n.ctaButton.signUp}
      </a>
